// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 1423 ? "route-GuestStayPage" : chunkId) + "." + {"1423":"412725b3","5671":"729b25b5","8206":"606554e3"}[chunkId] + ".chunk.css";
};